import {css} from 'styled-components';

export default css`

width: 500px;
padding: 5px;

&&& {    
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
`;
